export const ADD_CAMERA_CLUSTER = "ADD_CAMERA_CLUSTER";
export const UPDATE_CAMERA_CLUSTER = "UPDATE_CAMERA_CLUSTER";
export const CAMERA_CLUSTER_UPDATED = "CAMERA_CLUSTER_UPDATED";
export const CAMERA_CLUSTER_REMOVED = "CAMERA_CLUSTER_REMOVED";
export const INITIAL_CAMERA_CLUSTERS_BATCH_RECEIVED = "INITIAL_CAMERA_CLUSTERS_BATCH_RECEIVED";
export const REMOVE_CAMERA_CLUSTERS = "REMOVE_CAMERA_CLUSTERS";
export const UPDATE_CLUSTER_CAMERASLOTS = "UPDATE_CLUSTER_CAMERASLOTS";
export const UPDATE_CAMERA_CLUSTER_ROWS_AND_COLUMNS = "UPDATE_CAMERA_CLUSTER_ROWS_AND_COLUMNS";
export const RESET_CAMERA_CLUSTER_ROWS_AND_COLUMNS_TO_DEFAULT = "RESET_CAMERA_CLUSTER_ROWS_AND_COLUMNS_TO_DEFAULT";
